import { createStyles, rem } from "@mantine/core"

interface StepUseStylesProps {
    isActive: boolean
    isConcluded: boolean
    disabled: boolean
}

export const useStyles = createStyles((theme, { isActive, disabled, isConcluded }: StepUseStylesProps) => ({
    container: {
        alignItems: "center",
        justifyContent: "flex-start",
        gap: rem(12),
        cursor: disabled ? "not-allowed" : "pointer",
        color: isActive && !disabled ? "white" : theme.colors.gray[7],
        whiteSpace: "nowrap",
    },
    step: {
        minWidth: rem(32),
        minHeight: rem(32),
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isConcluded
            ? theme.colors.green[5]
            : isActive && !disabled
              ? theme.colors.violet[7]
              : theme.colors.gray[1],
    },
    checkIcon: {
        color: "white",
    },
    label: {
        fontWeight: 500,
        color: isActive && !disabled && !isConcluded ? theme.colors.violet[7] : "inherit",
        [theme.fn.smallerThan("md")]: {
            display: "none",
        },
    },
    divider: {
        backgroundColor: "transparent",
        width: "5rem",
        height: rem(2),
        borderTop: `1px solid ${theme.colors.gray[2]}`,
        [theme.fn.smallerThan("xs")]: {
            width: rem(0),
        },
    },
}))
